import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <style type="text/css">
        {`
          .st0{fill:#111111;}
          .st1{fill:none;stroke:#111111;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
        `}
      </style>
      <g>
        <g>
          <path
            class="st0"
            d="M123.6,341.3h9.8c15.1,0,27.5,12.4,27.5,27.5v81.9c0,15.1-12.4,27.5-27.5,27.5h-9.8
			c-15.1,0-27.5-12.4-27.5-27.5v-81.9C96.1,353.6,108.4,341.3,123.6,341.3z"
          />
        </g>
        <g>
          <path
            class="st0"
            d="M377.2,341.3h10.4c15.2,0,27.7,12.5,27.7,27.7v81.4c0,15.2-12.5,27.7-27.7,27.7h-10.4
			c-15.2,0-27.7-12.5-27.7-27.7V369C349.5,353.7,362,341.3,377.2,341.3z"
          />
        </g>
        <path
          class="st1"
          d="M159.5,392.4l0-25.6c0.1-13.4-10.8-24.3-24.2-24.3H120c-13.4,0-24.3,10.9-24.3,24.3v84.7
		c0,13.4,10.9,24.3,24.3,24.3h15.2c13.4,0,24.3-10.9,24.3-24.3l0-24.8h190.7l0,24.8c0,13.4,10.9,24.3,24.3,24.3h15.2
		c13.4,0,24.3-10.9,24.3-24.3v-84.7c0-13.4-10.9-24.3-24.3-24.3h-15.2c-13.4,0-24.3,10.9-24.2,24.3l0,25.6h-76.5V116.6h76.5l0,25.6
		c-0.1,13.4,10.8,24.3,24.2,24.3h15.2c13.4,0,24.3-10.9,24.3-24.3V57.5c0-13.4-10.9-24.3-24.3-24.3h-15.2
		c-13.4,0-24.3,10.9-24.3,24.3l0,24.8H159.5l0-24.8c0-13.4-10.9-24.3-24.3-24.3H120c-13.4,0-24.3,10.9-24.3,24.3v84.7
		c0,13.4,10.9,24.3,24.3,24.3h15.2c13.4,0,24.3-10.9,24.2-24.3l0-25.6h77.2v275.7H159.5z"
        />
      </g>
    </svg>
  );
};

export default Icon;
